import {URL_BASE_API } from '../configs/urlConfigs';

import service from './api';

export const eventListBKUP = (request) => { 
    let ENDPOINT = URL_BASE_API+'events/events/'; 
    if(request.data!==undefined){
        if(request.data.page === 0){
            let pageId   = request.data.page;
            ENDPOINT = URL_BASE_API+'events/events/?page='+pageId
        }else{
            let isEvent   = request.data.isEvent; 
            let pageId   = request.data.page;
            let column   = request.data.column;   
            let pageSize = request.data.pageSize; 
            let search   = request.data.search;  
            ENDPOINT = URL_BASE_API+'events/events/?search='+search+'&is_event='+isEvent+'&page='+pageId+'&column='+column+'&page_size='+pageSize;
        }
          
    }
    return service.get(ENDPOINT); 
}; 


export const eventList = (request) => { 
    let ENDPOINT = URL_BASE_API+'events/events/'; 
    if(request.data!==undefined){

        if(request.data && request.data.applyFilter && request.data.applyFilter > 0) {
            ENDPOINT = URL_BASE_API+'events/events/?filter=1'; 
            if(request.data.isEvent >= 0) ENDPOINT += '&is_event='+request.data.isEvent; 
            // pageSize:0,page:0,column:this.state.sortOrder+this.state.sortField,search:this.state.searchQuote,applyFilter:filterApplied,filtersData:filtersData,csvDownload:1
            let csvDownload = 0; 
            if(request.data.csvDownload && Number(request.data.csvDownload) > 0) csvDownload = Number(request.data.csvDownload);
            if(csvDownload > 0) { // FOR SCV DOWNLOAD, SEND page AS 0
                ENDPOINT += '&page=0';   
            } else  {
                if(request.data.page && request.data.page > 0) ENDPOINT += '&page='+request.data.page; 
                if(request.data.pageSize && request.data.pageSize > 0) ENDPOINT += '&page_size='+request.data.pageSize;     
            }
            
            if(request.data.search && request.data.search.length) ENDPOINT += '&search='+request.data.search; 
            if(request.data.column && request.data.column.length) ENDPOINT += '&column='+request.data.column; 

            let filtersData = request.data.filtersData; 
            let affiliateIds = 0; 
            let clientsIds = 0; 
            let eventIds = 0; 
            let locIds = 0; 
            let eventStatIds = 0; 
            let quoteStatIds = 0; 
            let departments = 0; 
            let cancelReasons = 0; 

            if(filtersData.affiliateIds && filtersData.affiliateIds.length) affiliateIds = JSON.stringify(filtersData.affiliateIds);
            if(filtersData.clientsIds && filtersData.clientsIds.length) clientsIds = JSON.stringify(filtersData.clientsIds);
            if(filtersData.eventIds && filtersData.eventIds.length)  eventIds = JSON.stringify(filtersData.eventIds); 
            if(filtersData.locIds && filtersData.locIds.length)  locIds = JSON.stringify(filtersData.locIds); 
            if(filtersData.eventStatIds && filtersData.eventStatIds.length)  eventStatIds = JSON.stringify(filtersData.eventStatIds); 
            if(filtersData.quoteStatIds && filtersData.quoteStatIds.length)  quoteStatIds = JSON.stringify(filtersData.quoteStatIds); 
            if(filtersData.departments && filtersData.departments.length)  departments = JSON.stringify(filtersData.departments); 
            if(filtersData.cancelReasons && filtersData.cancelReasons.length)  cancelReasons = JSON.stringify(filtersData.cancelReasons); 
            
            if(affiliateIds)    ENDPOINT += '&affiliates='+affiliateIds; 
            if(clientsIds)      ENDPOINT += '&clients='+clientsIds; 
            if(eventIds)        ENDPOINT += '&events='+eventIds;  
            if(locIds)          ENDPOINT += '&locations='+locIds;  
            if(eventStatIds)    ENDPOINT += '&event_status='+eventStatIds;  
            if(quoteStatIds)    ENDPOINT += '&quote_status='+quoteStatIds;  
            if(departments)     ENDPOINT += '&departments='+departments;  
            if(cancelReasons)   ENDPOINT += '&cancel_reasons='+cancelReasons;  
            if(filtersData.shiftTimeChangeRequest !== undefined) ENDPOINT += '&shift_time_change_requests='+filtersData.shiftTimeChangeRequest;  
            if(filtersData.selDateType.length > 1 &&  filtersData.selectedStartDate && filtersData.selectedStartDate.length)  ENDPOINT += '&date_type='+filtersData.selDateType+'&from_date='+filtersData.selectedStartDate+'&to_date='+filtersData.selectedEndDate;  
            // ?clients=[2]&events=[59]&shifts=[32]&locations=[12]&event_status=[1]&shift_status=[8, 1]&from_date=2020-06-01&to_date=2020-07-30&filter=1
        }
        else {
            let isEvent  = request.data.isEvent ? request.data.isEvent : 0; 
            let column   = request.data.column;   
            let search   = request.data.search;  
            if(request.data.csvDownload && Number(request.data.csvDownload) > 0){
                ENDPOINT = URL_BASE_API+'events/events/?page=0&search='+search+'&is_event='+isEvent+'&column='+column;
            }
            else if(request.data.page === 0){
                let pageId   = request.data.page;
                ENDPOINT = URL_BASE_API+'events/events/?page='+pageId; 
                if(request.data.isEvent >= 0) ENDPOINT += '&is_event='+request.data.isEvent; 
            }else{
                let pageId   = request.data.page;
                let pageSize = request.data.pageSize; 
                ENDPOINT = URL_BASE_API+'events/events/?search='+search+'&is_event='+isEvent+'&column='+column+'&page='+pageId+'&page_size='+pageSize;
            }
        }
    }
    return service.get(ENDPOINT); 
}; 

export const invoiceList = (request) => { 
    let ENDPOINT = URL_BASE_API+'events/export-invoices/'; 
    if(request.data!==undefined){
        if(request.data && request.data.event_id){
            ENDPOINT += '?event_id='+ request.data.event_id;
        }
        else if(request.data && request.data.applyFilter && request.data.applyFilter > 0) {
            ENDPOINT = URL_BASE_API+'events/export-invoices/?filter=1'; 
            if(request.data.isEvent >= 0) ENDPOINT += '&is_event='+request.data.isEvent; 
            // pageSize:0,page:0,column:this.state.sortOrder+this.state.sortField,search:this.state.searchQuote,applyFilter:filterApplied,filtersData:filtersData,csvDownload:1
            let csvDownload = 0; 
            if(request.data.csvDownload && Number(request.data.csvDownload) > 0) csvDownload = Number(request.data.csvDownload);
            if(csvDownload > 0) { // FOR SCV DOWNLOAD, SEND page AS 0
                ENDPOINT += '&page=0';   
            } else  {
                if(request.data.page && request.data.page > 0) ENDPOINT += '&page='+request.data.page; 
                if(request.data.pageSize && request.data.pageSize > 0) ENDPOINT += '&page_size='+request.data.pageSize;     
            }
            
            if(request.data.search && request.data.search.length) ENDPOINT += '&search='+request.data.search; 
            if(request.data.column && request.data.column.length) ENDPOINT += '&column='+request.data.column; 

            let filtersData = request.data.filtersData; 
            let affiliateIds = 0; 
            let clientsIds = 0; 
            let eventIds = 0; 
            let locIds = 0; 
            let eventStatIds = 0; 
            let quoteStatIds = 0; 

            if(filtersData.affiliateIds && filtersData.affiliateIds.length) affiliateIds = JSON.stringify(filtersData.affiliateIds);
            if(filtersData.clientsIds && filtersData.clientsIds.length) clientsIds = JSON.stringify(filtersData.clientsIds);
            if(filtersData.eventIds && filtersData.eventIds.length)  eventIds = JSON.stringify(filtersData.eventIds); 
            if(filtersData.locIds && filtersData.locIds.length)  locIds = JSON.stringify(filtersData.locIds); 
            if(filtersData.eventStatIds && filtersData.eventStatIds.length)  eventStatIds = JSON.stringify(filtersData.eventStatIds); 
            if(filtersData.quoteStatIds && filtersData.quoteStatIds.length)  quoteStatIds = JSON.stringify(filtersData.quoteStatIds); 
            
            if(affiliateIds)    ENDPOINT += '&affiliates='+affiliateIds; 
            if(clientsIds)      ENDPOINT += '&clients='+clientsIds; 
            if(eventIds)        ENDPOINT += '&events='+eventIds;  
            if(locIds)          ENDPOINT += '&locations='+locIds;  
            if(eventStatIds)    ENDPOINT += '&event_status='+eventStatIds;  
            if(quoteStatIds)    ENDPOINT += '&quote_status='+quoteStatIds;  
            if(filtersData.selDateType.length > 1 &&  filtersData.selectedStartDate && filtersData.selectedStartDate.length)  ENDPOINT += '&date_type='+filtersData.selDateType+'&from_date='+filtersData.selectedStartDate+'&to_date='+filtersData.selectedEndDate;  
            // ?clients=[2]&events=[59]&shifts=[32]&locations=[12]&event_status=[1]&shift_status=[8, 1]&from_date=2020-06-01&to_date=2020-07-30&filter=1
        }
        else {
            let isEvent  = request.data.isEvent ? request.data.isEvent : 0; 
            let column   = request.data.column;   
            let search   = request.data.search;  
            if(request.data.csvDownload && Number(request.data.csvDownload) > 0){
                ENDPOINT = URL_BASE_API+'events/export-invoices/?page=0&search='+search+'&is_event='+isEvent+'&column='+column;
            }
            else if(request.data.page === 0){
                let pageId   = request.data.page;
                ENDPOINT = URL_BASE_API+'events/export-invoices/?page='+pageId; 
                if(request.data.isEvent >= 0) ENDPOINT += '&is_event='+request.data.isEvent; 
            }else{
                let pageId   = request.data.page;
                let pageSize = request.data.pageSize; 
                ENDPOINT = URL_BASE_API+'events/export-invoices/?search='+search+'&is_event='+isEvent+'&column='+column+'&page='+pageId+'&page_size='+pageSize;
            }
        }
    }
    return service.get(ENDPOINT); 
}; 

export const eventAdd = (request) => {
    const ENDPOINT = URL_BASE_API+'events/events/';
  
    return service.post(ENDPOINT,request.data);  
};

export const eventEdit = (request) => {
    let eventId = request.data;
    const ENDPOINT = URL_BASE_API+'events/event/'+eventId;
  
    return service.get(ENDPOINT);      
};

export const eventUpdate = (request) => {
    let eventId = request.data.id;
    const ENDPOINT = URL_BASE_API+'events/event/'+eventId;
    delete request.data.id;
    return service.put(ENDPOINT,request.data);
};

export const eventDelete = (request) => {
    let eventId = request.data;
    const ENDPOINT = URL_BASE_API+'events/event/'+eventId;
    return service.delete(ENDPOINT);
};

export const eventCancel = (request) => {
    let eventId = request.data.eventId;
    let cancelReasonId = request.data.cancelReasonId;
    const ENDPOINT = URL_BASE_API+'events/cancel-event/'+eventId;
    return service.put(ENDPOINT,request.data);
};

export const quoteAccept = (request) => {
    let eventId = '';
    if(request.data instanceof FormData){
      eventId = request.data.get('eventId');
    }else{
        eventId = request.data.eventId;
    }
    const ENDPOINT = URL_BASE_API+'events/accept-quote/'+eventId;  
    return service.put(ENDPOINT,request.data);
};

export const quoteDecline = (request) => {
    let eventId = request.data;
    const ENDPOINT = URL_BASE_API+'events/decline-quote/'+eventId;
  
    return service.put(ENDPOINT,request.data);
};

export const shiftAdd = (request) => {
    const ENDPOINT = URL_BASE_API+'events/shift/';
  
    return service.post(ENDPOINT,request.data);  
};

export const shiftList = (request) => {
    let ENDPOINT = '';
    if(request.data !== undefined){
        
        if(request.data.applyFilter && request.data.applyFilter > 0) {
            ENDPOINT = URL_BASE_API+'events/shift/?filter=1'; 
            if(request.data.page && request.data.page > 0) ENDPOINT += '&page='+request.data.page; 
            if(request.data.column && request.data.column.length) ENDPOINT += '&column='+request.data.column; 
            if(request.data.pageSize && request.data.pageSize > 0) ENDPOINT += '&page_size='+request.data.pageSize; 
            if(request.data.search && request.data.search.length>0)ENDPOINT += '&title='+encodeURIComponent(request.data.search);
            let filtersData = request.data.filtersData; 
            let clientsIds = 0; 
            let eventIds = 0; 
            let shiftIds = 0; 
            let locIds = 0; 
            let eventStatIds = 0; 
            let shiftStatusIds = 0;
            let departments = 0;
            if(filtersData.clientsIds && filtersData.clientsIds.length) clientsIds = JSON.stringify(filtersData.clientsIds);
            if(filtersData.eventIds && filtersData.eventIds.length)  eventIds = JSON.stringify(filtersData.eventIds); 
            if(filtersData.shiftIds && filtersData.shiftIds.length)  shiftIds = JSON.stringify(filtersData.shiftIds); 
            if(filtersData.locIds && filtersData.locIds.length)  locIds = JSON.stringify(filtersData.locIds); 
            if(filtersData.eventStatIds && filtersData.eventStatIds.length)  eventStatIds = JSON.stringify(filtersData.eventStatIds); 
            if(filtersData.shiftStatusIds && filtersData.shiftStatusIds.length)  shiftStatusIds = JSON.stringify(filtersData.shiftStatusIds); 
            if(filtersData.departments && filtersData.departments.length)  departments = JSON.stringify(filtersData.departments); 
            
            if(clientsIds)      ENDPOINT += '&clients='+clientsIds; 
            if(eventIds)        ENDPOINT += '&events='+eventIds;  
            if(shiftIds)        ENDPOINT += '&shifts='+shiftIds;  
            if(locIds)          ENDPOINT += '&locations='+locIds;  
            if(eventStatIds)    ENDPOINT += '&event_status='+eventStatIds;  
            if(shiftStatusIds)  ENDPOINT += '&shift_status='+shiftStatusIds;
            if(departments)     ENDPOINT += '&departments='+departments;
            if(filtersData.selectedStartDate && filtersData.selectedStartDate.length)  ENDPOINT += '&from_date='+filtersData.selectedStartDate+'&to_date='+filtersData.selectedEndDate;  
            if(filtersData.unallocatedShift)  ENDPOINT += '&unallocated_shift='+filtersData.unallocatedShift; 
            
            // ?clients=[2]&events=[59]&shifts=[32]&locations=[12]&event_status=[1]&shift_status=[8, 1]&from_date=2020-06-01&to_date=2020-07-30&filter=1
        }
        else {
            let eventId  = request.data.eventId;
            let pageId   = request.data.page;
            let column   = request.data.column;   
            let pageSize = request.data.pageSize; 
            let search   = encodeURIComponent(request.data.search);  
            if(eventId){
                ENDPOINT = URL_BASE_API+'events/shift/?event_id='+eventId;
            }
            if(pageId||column||pageSize||search){
                ENDPOINT = URL_BASE_API+'events/shift/?title='+search+'&page='+pageId+'&column='+column+'&page_size='+pageSize;
            }
        }
        
    }
  
    return service.get(ENDPOINT);  
};

export const shiftIndividualDetails = (request) => {
    const ENDPOINT = URL_BASE_API+'events/shift-quote-summary/'+request.data;
  
    return service.get(ENDPOINT);  
};

export const shiftEdit = (request) => { 
    const ENDPOINT = URL_BASE_API+'events/shift/'+request.data;
  
    return service.get(ENDPOINT);  
};

export const shiftCancel = (request) => {
    let shiftId = request.data;
    const ENDPOINT = URL_BASE_API+'events/cancel-shift/'+shiftId;
    return service.put(ENDPOINT,request.data);
};

export const shiftSummary = (request) => {
    const ENDPOINT = URL_BASE_API+'events/shift-summary/'+request.data; 
    return service.get(ENDPOINT);  
};

export const shiftSummaryAllCrew = (request) => {
    const ENDPOINT = URL_BASE_API+'events/shift-scheduled-crew-details/'+request.data; 
    return service.get(ENDPOINT);  
};

export const eventClientDetails = (request) => {
    const ENDPOINT = URL_BASE_API+'events/event-client-details/'+request.data;
    return service.get(ENDPOINT);  
};

export const generateInvoice = (request) => {
    const ENDPOINT = URL_BASE_API + 'events/make-event-invoice/' + request.data;
    return service.get(ENDPOINT);
};

export const eventAffiliateDetails = (request) => {
    const ENDPOINT = URL_BASE_API+'events/event-affiliate-details/'+request.data;
    return service.get(ENDPOINT);  
};

export const eventSummaryList = (request) => {
    const ENDPOINT = URL_BASE_API+'events/event-summary/'+request.data;
    return service.get(ENDPOINT);  
};

export const quoteSummaryList = (request) => {
    const ENDPOINT = URL_BASE_API+'events/event-details/'+request.data;
    return service.get(ENDPOINT);  
};

export const quotePreview = (request) => {
    const ENDPOINT = URL_BASE_API+'events/quote-preview/'+request.data;
  
    return service.get(ENDPOINT);  
};

export const shiftUpdate = (request) => {
    let shiftId = request.data.id;
    const ENDPOINT = URL_BASE_API+'events/update-quote/'+shiftId;
    delete request.data.id;
    return service.put(ENDPOINT,request.data);
};

export const shiftDelete = (request) => {
    const ENDPOINT = URL_BASE_API+'events/shift/'+request.data;
    return service.delete(ENDPOINT);
};

export const quoteSendtoClient = (request) => {
    const ENDPOINT = URL_BASE_API+'events/send-quote/'+request.data;
    return service.get(ENDPOINT);
};

export const invoiceSendtoClient = (request) => {
    const ENDPOINT = URL_BASE_API+'events/send-invoice/'+request.data;
    return service.get(ENDPOINT);
};

export const quoteDownload = (request) => {
    const ENDPOINT = URL_BASE_API+'events/download-quote/'+request.data;
    return service.get(ENDPOINT);
};

export const eventShiftsStaffListPDFDownload = (request) => {
    if(request.data!==undefined){
        let ENDPOINT = URL_BASE_API+'events/export-shift-crew-list-pdf/'+request.data.eventId;
        let sepVal = '?'; 
        if(request.data?.name) {
            ENDPOINT += sepVal+'name=1'; 
            sepVal = '&';
        }
        if(request.data?.photo) {
            ENDPOINT += sepVal+'photo=1'; 
            sepVal = '&';
        } 
        if(request.data?.phone) {
            ENDPOINT += sepVal+'phone=1';  
            sepVal = '&';
        }
        if(request.data?.email) {
            ENDPOINT += sepVal+'email=1';  
            sepVal = '&';
        }
        if(request.data?.address) {
            ENDPOINT += sepVal+'address=1';  
            sepVal = '&';
        }
        if(request.data?.position) {
            ENDPOINT += sepVal+'position=1';  
            sepVal = '&';
        }
        if(request.data?.skill) {
            ENDPOINT += sepVal+'skill=1';  
            sepVal = '&';
        }
        return service.get(ENDPOINT);
    }
};

export const invoiceDownload = (request) => {
    const ENDPOINT = URL_BASE_API+'events/download-invoice/'+request.data;
    return service.get(ENDPOINT);
};

export const quoteRequest = (request) => {
    const ENDPOINT = URL_BASE_API+'events/request-quote/'+request.data;
    return service.put(ENDPOINT,request.data);
};

export const eventCalenderList = (request) => {
    const ENDPOINT = URL_BASE_API+'events/calendar-events/?month=5&year=2020';
    return service.get(ENDPOINT);
};

export const eventExport = (request) => {
    const ENDPOINT = URL_BASE_API+'events/export-events/?all=False&ids=20';
    return service.get(ENDPOINT);
};

export const eventGetChiefCrewCount = (request) => {
    let ENDPOINT = URL_BASE_API+'user/affiliate-crew-count-chief/';
    if(request.data!==undefined){
        ENDPOINT = URL_BASE_API+'user/affiliate-crew-count-chief/?affiliate='+request.data;
    }
    return service.get(ENDPOINT);
};

export const eventUserActionLogs = (request) => {
    let ENDPOINT = '';
    if(request.data!==undefined){
        let eventId = request.data.eventId;
        let shiftId = request.data.shiftId;
        let pageSize = request.data.pageSize;
        if(eventId){
            ENDPOINT = URL_BASE_API+'fetch-logs/?page_size='+pageSize+'&event_id='+eventId;
        }else if(shiftId){
            ENDPOINT = URL_BASE_API+'fetch-logs/?page_size='+pageSize+'&shift_id='+shiftId;
        }
    }
    return service.get(ENDPOINT);
};

export const eventClientAffiliateList = (request) => {
    const ENDPOINT = URL_BASE_API+'user/client-affiliates/'+request.data;
    return service.get(ENDPOINT);
};


export const eventCalendarList = (request) => {
    let month = request.data.month;
    let year = request.data.year;
    let isEvent = request.data.isEvent;
    let ENDPOINT = URL_BASE_API+'events/calendar-events/?is_event='+isEvent+'&month='+month+'&year='+year;

    if(request.data.applyFilter && request.data.applyFilter > 0) {
        ENDPOINT += '&filter=1';         
        // if(request.data.search && request.data.search.length > 0) ENDPOINT += '&search='+request.data.search; 
        let filtersData = request.data.filtersData; 
        let clientsIds = 0; 
        let eventIds = 0; 
        let locIds = 0; 
        let eventStatIds = 0; 
        let quoteStatIds = 0; 

        if(filtersData.clientsIds && filtersData.clientsIds.length) clientsIds = JSON.stringify(filtersData.clientsIds);
        if(filtersData.eventIds && filtersData.eventIds.length)  eventIds = JSON.stringify(filtersData.eventIds); 
        if(filtersData.locIds && filtersData.locIds.length)  locIds = JSON.stringify(filtersData.locIds); 
        if(filtersData.eventStatIds && filtersData.eventStatIds.length)  eventStatIds = JSON.stringify(filtersData.eventStatIds); 
        if(filtersData.quoteStatIds && filtersData.quoteStatIds.length)  quoteStatIds = JSON.stringify(filtersData.quoteStatIds); 
        
        if(clientsIds)      ENDPOINT += '&clients='+clientsIds; 
        if(eventIds)        ENDPOINT += '&events='+eventIds;  
        if(locIds)          ENDPOINT += '&locations='+locIds;  
        if(eventStatIds)    ENDPOINT += '&event_status='+eventStatIds;  
        // if(quoteStatIds)    ENDPOINT += '&quote_status='+quoteStatIds; 

        // if(filtersData.selDateType.length > 1 &&  filtersData.selectedStartDate && filtersData.selectedStartDate.length)  ENDPOINT += '&date_type='+filtersData.selDateType+'&from_date='+filtersData.selectedStartDate+'&to_date='+filtersData.selectedEndDate;  
        // ?clients=[2]&events=[59]&shifts=[32]&locations=[12]&event_status=[1]&shift_status=[8, 1]&from_date=2020-06-01&to_date=2020-07-30&filter=1
    }
    
    return service.get(ENDPOINT);
};

export const shiftGetDetails = (request) => { 
    const ENDPOINT = URL_BASE_API+'events/shift/'+request.data;
  
    return service.get(ENDPOINT);  
};

export const shiftScheduleList =(request) =>{ 
    const ENDPOINT = URL_BASE_API+'events/shifts-for-schedule/'+request.data;
    return service.get(ENDPOINT);
}

export const shiftScheduleCrew =(request) =>{ 
    let ENDPOINT = '';

    let skills = JSON.stringify(request.data.skills);
    let shifts = JSON.stringify(request.data.shifts);
    let departments = JSON.stringify(request.data.departments);
    let chief = request.data.chief;
    let page = request.data.page;
    let pageSize = request.data.pageSize;
    let crewName = request.data.crewName;
    let filter = request.data.filter;
    let ratingFrom = request.data.ratingFrom;
    let ratingTo = request.data.ratingTo;
    let pointFrom = request.data.pointFrom;
    // let has_vehicle = request.data.has_vehicle;
    let pointTo = request.data.pointTo;
    let payLevel = JSON.stringify(request.data.payLevel);

    if(filter===1){
        ENDPOINT = URL_BASE_API+'events/get-crews-for-shift-schedule-old/?skills='+skills+'&shifts='+shifts+'&chief='+chief+'&page='+page+'&page_size='+pageSize+'&crew_name='+crewName+'&filter='+filter+'&rating_from='+ratingFrom+'&rating_to='+ratingTo+'&point_from='+pointFrom+'&point_to='+pointTo+'&pay_levels='+payLevel+'&departments='+departments;
        // if(has_vehicle.length) ENDPOINT += '&has_vehicle='+has_vehicle; 
    }else{
        ENDPOINT = URL_BASE_API+'events/get-crews-for-shift-schedule-old/?skills='+skills+'&shifts='+shifts+'&chief='+chief+'&page='+page+'&page_size='+pageSize+'&crew_name='+crewName+'&departments='+departments;
    }
   
    return service.get(ENDPOINT);
}

export const scheduleShiftCrew =(request) =>{ 
    let ENDPOINT = '';

    let shifts = JSON.stringify(request.data.shifts);
    let departments = JSON.stringify(request.data.departments);
    let page = request.data.page;
    let pageSize = request.data.pageSize;
    let crewName = request.data.crewName;
    let filter = request.data.filter;
    let ratingFrom = request.data.ratingFrom;
    let ratingTo = request.data.ratingTo;
    let pointFrom = request.data.pointFrom;
    let pointTo = request.data.pointTo;
    let has_vehicle = request.data.hasVehicle;
    let payLevel = JSON.stringify(request.data.payLevel);
    let selectedSkill = request.data.selectedSkill ? request.data.selectedSkill : 0;
    let showOnlyChief = request.data.showOnlyChief ? request.data.showOnlyChief : 0;
    let multi_shift = request.data.multi_shift ? request.data.multi_shift : 0;
    let omnu_pool = request.data.omnu_pool;
    let sort_by = request.data.sortBy;
    if(filter===1){
        ENDPOINT = URL_BASE_API+'events/get-crews-for-shift-schedule/?sort_by='+sort_by+'&shifts='+shifts+'&page='+page+'&page_size='+pageSize+'&crew_name='+crewName+'&filter='+filter+'&rating_from='+ratingFrom+'&rating_to='+ratingTo+'&point_from='+pointFrom+'&point_to='+pointTo+'&pay_levels='+payLevel+'&departments='+departments+'&omnu_pool='+omnu_pool;
        if(selectedSkill) ENDPOINT += '&skills=['+selectedSkill+']'; 
        if(showOnlyChief) ENDPOINT += '&chief='+showOnlyChief; 
        if(has_vehicle !== '') ENDPOINT += '&has_vehicle='+has_vehicle; 
        // if(has_vehicle.length) ENDPOINT += '&has_vehicle='+has_vehicle;
        ENDPOINT += '&multi_shift='+multi_shift; 
    }else{
        ENDPOINT = URL_BASE_API+'events/get-crews-for-shift-schedule/?sort_by='+sort_by+'&shifts='+shifts+'&page='+page+'&page_size='+pageSize+'&crew_name='+crewName+'&omnu_pool='+omnu_pool; 
        if(selectedSkill) ENDPOINT += '&skills=['+selectedSkill+']'; 
        if(showOnlyChief) ENDPOINT += '&chief='+showOnlyChief; 
        ENDPOINT += '&multi_shift='+multi_shift; 
    }
    return service.get(ENDPOINT);
}

export const shiftScheduleCrewRequest = (request) =>{
    const ENDPOINT = URL_BASE_API+'events/send-schedule-request-to-crew/';
    return service.post(ENDPOINT,request.data);
}

export const shiftSkillCrewList =(request) =>{ 
    let skillId = request.data.skillId;
    let shiftId = request.data.shiftId;
    let isChief = request.data.isChief;
    const ENDPOINT = URL_BASE_API+'events/get-scheduled-crews-of-shiftskill/?skill_id='+skillId+'&shift_id='+shiftId+'&is_chief='+isChief;
    return service.get(ENDPOINT);
}

export const scheduleDateView = (request) => {
    let columnName = request.data.column; // 'crew__id'; 
    let page = request.data.page; 
    let pageSize = request.data.pageSize; 
    let search = request.data.search; 
    let ENDPOINT = URL_BASE_API+'events/schedule-details-date-view/?column='+columnName+'&page='+page+'&page_size='+pageSize+'&search='+search;

    if(request.data.applyFilter && request.data.applyFilter > 0) {
        ENDPOINT +='&filter=1'; 
        let filtersData = request.data.filtersData; 
        let clientsIds = 0; 
        let eventIds = 0; 
        let shiftIds = 0; 
        let eventStatIds = 0; 
        let shiftStatusIds = 0; 
        let scheduleStatusIds = 0; 
        let departmentIds = 0; 

        if(filtersData.clientsIds && filtersData.clientsIds.length) clientsIds = JSON.stringify(filtersData.clientsIds);
        if(filtersData.eventIds && filtersData.eventIds.length)  eventIds = JSON.stringify(filtersData.eventIds); 
        if(filtersData.shiftIds && filtersData.shiftIds.length)  shiftIds = JSON.stringify(filtersData.shiftIds); 
        if(filtersData.eventStatIds && filtersData.eventStatIds.length)  eventStatIds = JSON.stringify(filtersData.eventStatIds); 
        if(filtersData.shiftStatusIds && filtersData.shiftStatusIds.length)  shiftStatusIds = JSON.stringify(filtersData.shiftStatusIds); 
        if(filtersData.scheduleStatusIds && filtersData.scheduleStatusIds.length)  scheduleStatusIds = JSON.stringify(filtersData.scheduleStatusIds); 
        if(filtersData.departmentIds && filtersData.departmentIds.length)  departmentIds = JSON.stringify(filtersData.departmentIds); 
        
        if(clientsIds)          ENDPOINT += '&clients='+clientsIds; 
        if(eventIds)            ENDPOINT += '&events='+eventIds;  
        if(shiftIds)            ENDPOINT += '&shifts='+shiftIds;  
        if(eventStatIds)        ENDPOINT += '&event_status='+eventStatIds;  
        if(shiftStatusIds)      ENDPOINT += '&shift_status='+shiftStatusIds;  
        if(scheduleStatusIds)   ENDPOINT += '&schedule_status='+scheduleStatusIds;  
        if(departmentIds)       ENDPOINT += '&department_ids='+departmentIds;  
        if(filtersData.selectedStartDate && filtersData.selectedStartDate.length)  ENDPOINT += '&from_date='+filtersData.selectedStartDate+'&to_date='+filtersData.selectedEndDate; 
        return service.get(ENDPOINT);    
    }
    else {
        return service.get(ENDPOINT);    
    }
};

export const scheduleCrewView = (request) => {
    let columnName = request.data.column; // 'crew__id'; 
    let page = request.data.page; 
    let pageSize = request.data.pageSize; 
    let search = request.data.search; 

    let ENDPOINT = URL_BASE_API+'events/schedule-details-crew-view/?column='+columnName+'&search='+search+'&page='+page+'&page_size='+pageSize;

    if(request.data.applyFilter && request.data.applyFilter > 0) {
        ENDPOINT +='&filter=1'; 
        let filtersData = request.data.filtersData; 
        let clientsIds = 0; 
        let eventIds = 0; 
        let shiftIds = 0; 
        let eventStatIds = 0; 
        let shiftStatusIds = 0; 
        let scheduleStatusIds = 0; 
        let departmentIds = 0; 

        if(filtersData.clientsIds && filtersData.clientsIds.length) clientsIds = JSON.stringify(filtersData.clientsIds);
        if(filtersData.eventIds && filtersData.eventIds.length)  eventIds = JSON.stringify(filtersData.eventIds); 
        if(filtersData.shiftIds && filtersData.shiftIds.length)  shiftIds = JSON.stringify(filtersData.shiftIds); 
        if(filtersData.eventStatIds && filtersData.eventStatIds.length)  eventStatIds = JSON.stringify(filtersData.eventStatIds); 
        if(filtersData.shiftStatusIds && filtersData.shiftStatusIds.length)  shiftStatusIds = JSON.stringify(filtersData.shiftStatusIds); 
        if(filtersData.scheduleStatusIds && filtersData.scheduleStatusIds.length)  scheduleStatusIds = JSON.stringify(filtersData.scheduleStatusIds); 
        if(filtersData.departmentIds && filtersData.departmentIds.length)  departmentIds = JSON.stringify(filtersData.departmentIds); 
        if(clientsIds)          ENDPOINT += '&clients='+clientsIds; 
        if(eventIds)            ENDPOINT += '&events='+eventIds;  
        if(shiftIds)            ENDPOINT += '&shifts='+shiftIds;  
        if(eventStatIds)        ENDPOINT += '&event_status='+eventStatIds;  
        if(shiftStatusIds)      ENDPOINT += '&shift_status='+shiftStatusIds;  
        if(scheduleStatusIds)   ENDPOINT += '&schedule_status='+scheduleStatusIds;  
        if(departmentIds)       ENDPOINT += '&department_ids='+departmentIds;  
        if(filtersData.selectedStartDate && filtersData.selectedStartDate.length)  ENDPOINT += '&from_date='+filtersData.selectedStartDate+'&to_date='+filtersData.selectedEndDate; 
        return service.get(ENDPOINT);    
    }
    else {
        return service.get(ENDPOINT);    
    } 
};

export const filterClientsList =(request) =>{ 
    let ENDPOINT = URL_BASE_API+'user/affiliate-clients-filter/';
    let affiliates = request.data && request.data.affiliateIds && request.data.affiliateIds.length > 0 ? JSON.stringify(request.data.affiliateIds) : 0; 
    if(affiliates) ENDPOINT += '?affiliates='+affiliates; 
    return service.get(ENDPOINT);
}

export const shiftsFilterEventsList = (request) => { 
    let ENDPOINT = URL_BASE_API+'events/shift-filter-events/'; 
    if(request && request.data && request.data.clientsIds && request.data.clientsIds.length) {

        let clientsIds = JSON.stringify(request.data.clientsIds);
        ENDPOINT = URL_BASE_API+'events/shift-filter-events/?clients='+clientsIds; 
    }
    return service.get(ENDPOINT); 
}; 

export const shiftsFilterShiftsList = (request) => { 
    let ENDPOINT = URL_BASE_API+'events/shift-filter-shifts/'; // ?clients=[2]&events=[59] 
    let clientsIds = 0; 
    let eventIds = 0; 
    if(request && request.data) {
        if(request.data.clientsIds && request.data.clientsIds.length)  clientsIds = JSON.stringify(request.data.clientsIds); 
        if(request.data.eventIds && request.data.eventIds.length)  eventIds = JSON.stringify(request.data.eventIds); 
    }
    let sepVal = '?'; 
    if(clientsIds) {
        ENDPOINT += sepVal+'clients='+clientsIds; 
        sepVal = '&'; 
    }
    if(eventIds) {
        ENDPOINT += sepVal+'events='+eventIds;  
    }
    return service.get(ENDPOINT); 
}; 

export const shiftsFilterLocationsList = (request) => { 
    let ENDPOINT = URL_BASE_API+'events/shift-filter-locations/'; // ?clients=[2]&events=[59]&shifts=[168] 
    let clientsIds = 0; 
    let eventIds = 0; 
    let shiftIds = 0; 
    if(request && request.data) {
        if(request.data.clientsIds && request.data.clientsIds.length) clientsIds = JSON.stringify(request.data.clientsIds);
        if(request.data.eventIds && request.data.eventIds.length)  eventIds = JSON.stringify(request.data.eventIds); 
        if(request.data.shiftIds && request.data.shiftIds.length)  shiftIds = JSON.stringify(request.data.shiftIds); 
    }
    let sepVal = '?'; 
    if(clientsIds) {
        ENDPOINT += sepVal+'clients='+clientsIds; 
        sepVal = '&'; 
    }
    if(eventIds) {
        ENDPOINT += sepVal+'events='+eventIds;  
        sepVal = '&'; 
    }
    if(shiftIds) {
        ENDPOINT += sepVal+'shifts='+shiftIds;  
    }
    return service.get(ENDPOINT); 
}; 

export const eventsFilterEventsList = (request) => { 
    let isEvent = request.data.isEvent; 
    let ENDPOINT = URL_BASE_API+'events/event-filter-events/?is_event='+isEvent; 
    if(request.data.clientsIds && request.data.clientsIds.length > 0) {
        let clientsIds = JSON.stringify(request.data.clientsIds);
        ENDPOINT = URL_BASE_API+'events/event-filter-events/?is_event='+isEvent+'&clients='+clientsIds; 
    } 
    else if(request.data.affiliateIds && request.data.affiliateIds.length >0) {
        let affiliateIds = JSON.stringify(request.data.affiliateIds);
        ENDPOINT = URL_BASE_API+'events/event-filter-events/?is_event='+isEvent+'&affiliates='+affiliateIds; 
    } 

    return service.get(ENDPOINT); 
};  

export const eventsFilterLocationsList = (request) => { 
    let isEvent = request.data.isEvent; 
    let ENDPOINT = URL_BASE_API+'events/event-filter-locations/?is_event='+isEvent; // &clients=[2]&events=[68,59] 
    let clientsIds = 0; 
    let eventIds = 0; 
    let affiliateIds = 0; 

    if(request.data.clientsIds && request.data.clientsIds.length) clientsIds = JSON.stringify(request.data.clientsIds);
    if(request.data.eventIds && request.data.eventIds.length)  eventIds = JSON.stringify(request.data.eventIds); 
    if(request.data.affiliateIds && request.data.affiliateIds.length) affiliateIds = JSON.stringify(request.data.affiliateIds);
    
    if(clientsIds) {
        ENDPOINT += '&clients='+clientsIds; 
    }
    if(eventIds) {
        ENDPOINT += '&events='+eventIds;  
    }
    if(affiliateIds) {
        ENDPOINT += '&affiliates='+affiliateIds;  
    }
    return service.get(ENDPOINT); 
}; 


export const getNextShiftSeqNumber =(request) =>{
    let eventId = request.data;
    const ENDPOINT = URL_BASE_API+'events/next-shift-seqno/?event_id='+eventId;
    return service.get(ENDPOINT);
}

export const eventComplete = (request) => {
    let eventId = request.data;
    const ENDPOINT = URL_BASE_API+'events/make-event-completed/'+eventId;
    return service.put(ENDPOINT);
};

export const editQuoteDiscount = (request) => {
    let eventId = request.data.eventId;
    const ENDPOINT = URL_BASE_API+'events/update-event-discount/'+eventId;
    delete request.data.eventId;
    return service.put(ENDPOINT,request.data);
};

export const filterAffiliatesList =(request) =>{
    const ENDPOINT = URL_BASE_API+'user/affiliate-list/'; 
    return service.get(ENDPOINT);
}

export const listEventShifts = (request) => {
    const ENDPOINT = URL_BASE_API+'events/shifts-of-event/'+request.data;
    return service.get(ENDPOINT);  
};

export const listEventShiftCrew = (request) => {
    const ENDPOINT = URL_BASE_API+'events/shift-schedule-accepted-crew-details/'+request.data;
    return service.get(ENDPOINT);  
};

export const schedulesDateViewCalendar = (request) => {
    let column   = request.data.column;
    let month    = request.data.month;
    let year     = request.data.year;
    let ENDPOINT = URL_BASE_API+'events/schedule-details-calendar-view/?column='+column+'&month='+month+'&year='+year;

    if(request.data && request.data.applyFilter && request.data.applyFilter > 0) {
        // column=crew__user__first_name&clients=[2]&event_status=[6]&shift_status=[6]&filter=1&month=10&year=2020
        ENDPOINT += '&filter=1'; 
        let filtersData = request.data.filtersData; 
        let clientsIds = 0; 
        let eventStatIds = 0; 
        let shiftStatIds = 0; 
        let departmentIds = 0; 

        if(filtersData.clientsIds && filtersData.clientsIds.length) clientsIds = JSON.stringify(filtersData.clientsIds);
        if(filtersData.eventStatIds && filtersData.eventStatIds.length)  eventStatIds = JSON.stringify(filtersData.eventStatIds); 
        if(filtersData.shiftStatusIds && filtersData.shiftStatusIds.length)  shiftStatIds = JSON.stringify(filtersData.shiftStatusIds); 
        if(filtersData.departmentIds && filtersData.departmentIds.length)  departmentIds = JSON.stringify(filtersData.departmentIds); 
        
        if(clientsIds)      ENDPOINT += '&clients='+clientsIds; 
        if(eventStatIds)    ENDPOINT += '&event_status='+eventStatIds;  
        if(shiftStatIds)    ENDPOINT += '&shift_status='+shiftStatIds;  
        if(departmentIds)    ENDPOINT += '&department_ids='+departmentIds;  
    }

    return service.get(ENDPOINT);  
};

export const schedDateViewCalendarDate = (request) => {
    let column   = request.data.column;
    let selDate  = request.data.selDate;
    let ENDPOINT = URL_BASE_API+'events/schedule-details-day-view/?column='+column+'&date='+selDate;

    if(request.data && request.data.applyFilter && request.data.applyFilter > 0) {
        // events/schedule-details-day-view/?column=crew__user__first_name&date=2020-10-22&filter=1&shift_status=[4]&event_status=[]&clients=[]
        ENDPOINT += '&filter=1'; 
        let filtersData = request.data.filtersData; 
        let clientsIds = 0; 
        let eventStatIds = 0; 
        let shiftStatIds = 0; 
        let departmentIds = 0; 

        if(filtersData.clientsIds && filtersData.clientsIds.length) clientsIds = JSON.stringify(filtersData.clientsIds);
        if(filtersData.eventStatIds && filtersData.eventStatIds.length)  eventStatIds = JSON.stringify(filtersData.eventStatIds); 
        if(filtersData.shiftStatusIds && filtersData.shiftStatusIds.length)  shiftStatIds = JSON.stringify(filtersData.shiftStatusIds); 
        if(filtersData.departmentIds && filtersData.departmentIds.length)  departmentIds = JSON.stringify(filtersData.departmentIds); 
        
        if(clientsIds)      ENDPOINT += '&clients='+clientsIds; 
        if(eventStatIds)    ENDPOINT += '&event_status='+eventStatIds;  
        if(shiftStatIds)    ENDPOINT += '&shift_status='+shiftStatIds;  
        if(departmentIds)    ENDPOINT += '&department_ids='+departmentIds;  
    }

    return service.get(ENDPOINT);  
};

export const shiftCrewDownload = (request) => {
    let eventId = request.data;
    const ENDPOINT = URL_BASE_API+'events/export-shift-crew-list/'+eventId;
  
    return service.get(ENDPOINT);      
};


export const listEventMessages = (request) => {
    let eventId = request.data;
    const ENDPOINT = URL_BASE_API+'events/user-event-communications/?page=0&event_id='+eventId;  
    return service.get(ENDPOINT);      
};

export const sendEventMessage = (request) => {
    let eventId = request.data.eventId;
    let textMsg = request.data.textMsg;
    const ENDPOINT = URL_BASE_API+'events/user-event-communications/';  
    return service.post(ENDPOINT,{'message':textMsg,'event_id':eventId});     
};

export const shiftTimeChangeRequest = (request) => {
    const ENDPOINT = URL_BASE_API+'events/shift-time-change-status/';
    return service.post(ENDPOINT,request.data);
};


export const getUnallocatedShiftsCount = (request) => {
    let numDays = request.data ? request.data : 30; 
    const ENDPOINT = URL_BASE_API+'events/unallocated-shifts-count/?days='+numDays;
    return service.get(ENDPOINT);
};

export const addRemoveVehicle = (request) => {
    const ENDPOINT = URL_BASE_API+'events/add-remove-vehicle-info/';
    return service.post(ENDPOINT,request.data);
};
export const addRemoveVehicleShift = (request) => {
    const ENDPOINT = URL_BASE_API+'events/add-remove-vehicle-info/';
    return service.post(ENDPOINT,request.data);
};

export const listInvoice = (request) => {
    let eventId = request.data;
    const ENDPOINT = URL_BASE_API+'events/invoices/?event_id='+eventId;  
    return service.get(ENDPOINT);
};

export const invoicePreview = (request) => {
    let eventId = request.data;
    const ENDPOINT = URL_BASE_API+'events/invoice-preview/'+eventId;  
    return service.get(ENDPOINT);
};

export const updateInvoice = (request) => {
    const ENDPOINT = URL_BASE_API+'events/invoices/'; 
    return service.post(ENDPOINT,request.data);
};
export const availableAffVehicle = (request) => {
    let id = request.data
    const ENDPOINT = URL_BASE_API+'events/shift-affiliate-vehicles/?shift_id='+id; 
    return service.get(ENDPOINT);
};
export const addAffVehicle = (request) => {
    const ENDPOINT = URL_BASE_API+'events/shift-affiliate-vehicles/'; 
    return service.post(ENDPOINT,request.data);
};
export const removeAffVehicle = (request) => {
    const ENDPOINT = URL_BASE_API+'events/shift-affiliate-vehicles/'; 
    return service.put(ENDPOINT,request.data);
};

export const cancelReasonList = (request) => {
    let id = request.data
    const ENDPOINT = URL_BASE_API+'affiliate/aff-cancelled-reasons/?page=0&column=name'; 
    return service.get(ENDPOINT);
};

export const crewAvailabilityReportList = (request) => { 
    let page = request.data.page;
    let pageSize = request.data.pageSize;
    let ENDPOINT = URL_BASE_API+'events/crew-availability-report/?page='+page+'&page_size='+pageSize;
    let departmentIds = 0; 
    let skillIds = 0; 
    let payLevelIds = 0; 
    let startDateTime = request.data.startDateTime; 
    let endDateTime = request.data.endDateTime; 

    if(request.data.departmentIds && request.data.departmentIds.length) departmentIds = JSON.stringify(request.data.departmentIds);
    if(request.data.skillIds && request.data.skillIds.length)  skillIds = JSON.stringify(request.data.skillIds);
    if(request.data.payLevelIds && request.data.payLevelIds.length)  payLevelIds = JSON.stringify(request.data.payLevelIds);
    
    if(departmentIds) {
        ENDPOINT += '&department_ids='+departmentIds; 
    }
    if(skillIds) {
        ENDPOINT += '&skill_ids='+skillIds;  
    }
    if(payLevelIds) {
        ENDPOINT += '&pay_level_ids='+payLevelIds;  
    } 
    if(startDateTime) {
        ENDPOINT += '&start_date_time='+startDateTime;  
    }
    if(endDateTime) {
        ENDPOINT += '&end_date_time='+endDateTime;  
    }
    return service.get(ENDPOINT); 
}; 

export const clientDepartmentsByEventId = (request) => { // USED IN SHIFT ADD/EDIT 
    let eventId = request.data;
    const ENDPOINT = URL_BASE_API+'user/client-departments/?event_id='+eventId;  
    return service.get(ENDPOINT);
};

export const crewAvailSummaryReportList = (request) => { 
    let page = request.data.page;
    let pageSize = request.data.pageSize;
    let ENDPOINT = URL_BASE_API+'events/crew-availability-summary/?page='+page+'&page_size='+pageSize;
    let departmentIds = 0; 
    let skillIds = 0; 
    let payLevelIds = 0; 
    let startDateTime = request.data.startDateTime; 
    let endDateTime = request.data.endDateTime; 

    if(request.data.departmentIds && request.data.departmentIds.length) departmentIds = JSON.stringify(request.data.departmentIds);
    if(request.data.skillIds && request.data.skillIds.length)  skillIds = JSON.stringify(request.data.skillIds);
    if(request.data.payLevelIds && request.data.payLevelIds.length)  payLevelIds = JSON.stringify(request.data.payLevelIds);
    
    if(departmentIds) {
        ENDPOINT += '&department_ids='+departmentIds; 
    }
    if(skillIds) {
        ENDPOINT += '&skill_ids='+skillIds;  
    }
    if(payLevelIds) {
        ENDPOINT += '&pay_level_ids='+payLevelIds;  
    } 
    if(startDateTime) {
        ENDPOINT += '&start_date_time='+startDateTime;  
    }
    if(endDateTime) {
        ENDPOINT += '&end_date_time='+endDateTime;  
    }
    if(endDateTime) {
        ENDPOINT += '&end_date_time='+endDateTime;  
    }
    return service.get(ENDPOINT); 
}; 

// FETCH EVENT LIST - USED FROM SHIFT CALENDAR - DRAG AND DROP PAGE  
export const shiftCalendarEventsList = (request) => { 
    let ENDPOINT = URL_BASE_API+'events/calendar-events-data/'; 
    if(request.data!==undefined) { 
        ENDPOINT = URL_BASE_API+'events/calendar-events-data/?page=0&date_type='+request.data.date_type+'&from_date='+request.data.from_date+'&to_date='+request.data.to_date; 
        if(request.data.departments && request.data.departments.length)  ENDPOINT += '&departments='+JSON.stringify(request.data.departments); 
        if(request.data.clientsIds && request.data.clientsIds.length)  ENDPOINT += '&clients='+JSON.stringify(request.data.clientsIds); 
        if(request.data.eventIds && request.data.eventIds.length)  ENDPOINT += '&events='+JSON.stringify(request.data.eventIds); 
        if(request.data.locationIds && request.data.locationIds.length)  ENDPOINT += '&locations='+JSON.stringify(request.data.locationIds);
        if(request.data.selStaffAssigned && request.data.selStaffAssigned.length)  ENDPOINT += '&staff_assigned_status='+request.data.selStaffAssigned;
    }
    return service.get(ENDPOINT); 
}; 

// FETCH EVENT SHIFT LIST - USED FROM SHIFT CALENDAR - DRAG AND DROP PAGE  
export const shiftCalendarEventShiftsList = (request) => { 

    let ENDPOINT = URL_BASE_API+'events/calendar-shifts-data/'; 
    if(request.data!==undefined) { 
        ENDPOINT = URL_BASE_API+'events/calendar-shifts-data/?from_date='+request.data.from_date+'&to_date='+request.data.to_date+'&events='+JSON.stringify(request.data.event_ids); 

        let skillIds = 0; 
        let departmentIds = 0; 
        if(request.data.skills && request.data.skills.length)  skillIds = JSON.stringify(request.data.skills); 
        if(skillIds)  ENDPOINT += '&skills='+skillIds; 

        if(request.data.departments && request.data.departments.length)  departmentIds = JSON.stringify(request.data.departments); 
        if(departmentIds)  ENDPOINT += '&departments='+departmentIds; 

        if(request.data.is_chief && request.data.is_chief.length)     ENDPOINT += '&is_chief='+request.data.is_chief; 

        if(request.data.has_vehicle && request.data.has_vehicle.length)  ENDPOINT += '&has_vehicle='+request.data.has_vehicle; 
    }
    return service.get(ENDPOINT); 
};

// FETCH SHIFT DISTANCE FROM DEPARTMENT AND LOCATION
export const shiftCalcDistanceDeptLoc = (request) => { 

    let ENDPOINT = URL_BASE_API+'google-map-direction/'; 
    if(request.data!==undefined) { 
        ENDPOINT = URL_BASE_API+'google-map-direction/?origin='+request.data.originLatLng+'&destination='+request.data.destLatLng; 
    }
    return service.get(ENDPOINT); 
};
